import React, { useState} from "react";
import AdministraFeriados from "./AdministraFeriados";
import ConfiguraParte from "./ConfiguraParte";
import CambioCondicionMasivo from "./CambioCondicionMasivo";

const Configuraciones = () => {

    const [feriados, verConfiguracionFeriado] = useState(false)
    const [partes, verConfiguracionPartes] = useState(false)

    return (

        <>
            <div><button onClick={() => verConfiguracionPartes(!partes)} className="btn btn-danger">Gestion Partes</button>
                {partes ? <div><ConfiguraParte /></div> : ""}  </div>
            <div><button onClick={() => verConfiguracionFeriado(!feriados)} className="btn btn-warning">Feriados</button>
                {feriados ? <div><AdministraFeriados /></div> : ""}  </div>
<CambioCondicionMasivo/>
        </>
    )
}

export default Configuraciones